import axiosInstance from '../axios.config';
import { API_ENDPOINTS } from '../endpoints';
import { normalizeTransfer } from './transfers.normalize';
import { CallTransfer, PaginatedResponse, ApiResponse, FilterParams } from 'types';
import { mockTransfers } from 'mocks/mockServer';
import { dateStringToEpoch, dateStringToEpochEndOfDay } from 'utils/helpers';

const useMock = process.env.REACT_APP_USE_MOCK === 'true';

export const transfersService = {
  async getTransfers(params?: FilterParams & { organizationId?: string }): Promise<ApiResponse<PaginatedResponse<CallTransfer>>> {
    if (useMock) {
      return mockTransfers.getTransfers(params);
    }

    // Convert date strings to epoch timestamps for API
    const apiParams: any = { ...params };
    if (params?.dateFrom) {
      apiParams.fromDateEpoch = dateStringToEpoch(params.dateFrom);
      delete apiParams.dateFrom;
    }
    if (params?.dateTo) {
      apiParams.toDateEpoch = dateStringToEpochEndOfDay(params.dateTo);
      delete apiParams.dateTo;
    }
    // Convert frontend 1-based page to backend 0-based page
    if (params?.page !== undefined) {
      apiParams.page = Math.max(0, params.page - 1);
    }

    try {
      const response = await axiosInstance.get<ApiResponse<PaginatedResponse<CallTransfer>>>(
        API_ENDPOINTS.TRANSFERS,
        { params: apiParams }
      );

      // Normalise the row shape before it reaches the page — see
      // normalizeTransfer above for why the raw response cannot be used as-is.
      const body: any = response.data;
      if (body?.data?.data && Array.isArray(body.data.data)) {
        body.data.data = body.data.data.map(normalizeTransfer);
      }
      return body;
    } catch (error: any) {
      return {
        success: false,
        error: error.response?.data?.message || 'Failed to fetch transfers'
      };
    }
  }
};